import * as Preact from "preact"
import Pointer from "@frog/source/utility/Pointer.js"

import "@frog/source/views/app/components/Frame.view.less"

import sizes from "@frog/source/data/sizes.js"

export default class Frame {
    render() {
        return (
            <div class="Frame" style={this.style}
                onContextMenu={this.onContextMenu}
                onMouseDown={this.onMouseDown}
                onMouseUp={this.onMouseUp}
                onMouseMove={this.onMouseMove}
                onTouchStart={this.onTouchStart}
                onTouchEnd={this.onTouchEnd}
                onTouchMove={this.onTouchMove}>
                {this.props.children}
            </div>
        )
    }
    get style() {
        return {
            "width": sizes.frame.width + "em",
            "height": sizes.frame.height + "em"
        }
    }
    onContextMenu(event) {
        event.preventDefault()
    }
    onMouseDown(event) {
        Pointer.setPressed(event.button, true)
        Pointer.setPosition({
            "x": event.clientX,
            "y": event.clientY
        })
    }
    onMouseUp(event) {
        Pointer.setPressed(event.button, false)
        Pointer.setPosition({
            "x": event.clientX,
            "y": event.clientY
        })
    }
    onMouseMove(event) {
        Pointer.setPosition({
            "x": event.clientX,
            "y": event.clientY
        })
    }
    onTouchStart(event) {
        event.preventDefault()
        Pointer.setPressed(0, true)
        Pointer.setPosition({
            "x": event.touches[0].clientX,
            "y": event.touches[0].clientY
        })
    }
    onTouchEnd(event) {
        event.preventDefault()
        Pointer.setPressed(0, false)
        Pointer.setPosition({
            "x": event.touches[0].clientX,
            "y": event.touches[0].clientY
        })
    }
    onTouchMove(event) {
        Pointer.setPosition({
            "x": event.touches[0].clientX,
            "y": event.touches[0].clientY
        })
    }
}
